import PublicServiceWithdrawBottomSheet, {
  PublicServiceWithdrawBottomSheetProps,
} from '@di-shared/features/public-service/PublicServiceWithdrawBottomSheet';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 400;

function PublicServiceWithdrawBottomSheetPage() {
  const {vin, category} = (window as any).data as PublicServiceWithdrawBottomSheetProps;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <PublicServiceWithdrawBottomSheet
        vin={vin}
        category={category}
      />
    </BottomSheetWebViewWrapper>
  );
}

export default PublicServiceWithdrawBottomSheetPage;
